import { collection, getDoc, setDoc } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { getDocs, doc } from 'firebase/firestore'
import { auth, db } from "../../firebase";
import Studentnav from './Studentnav';

function DashmiuBoard() {
    const [joblist, setJoblist] = useState([]);
  //  const [status,setstatus] = useState("");
  const ref = collection(db, `appliedin/${auth.currentUser.uid}/applieds`);
  
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);
  return (
    <>
    <Studentnav/>
    <div className='mainn'>
    <div className="recipes">
    {
        joblist.map((eve)=>{
            return <>
             <div className="recipe">
            

            <div className="preedit">
                    <span className="postedit">Comapany Name :  </span>{" "}
                    {eve.cname} {" "}
            </div>
            <div className="preedit">
                    <span className="postedit">salary : </span>{" "}
                    {eve.salary}{" "}
                  </div>
                  <div className="preedit">
                    <span className="postedit">Position : </span>{" "}
                    {eve.position}{" "}
                  </div>
                  <div className="preedit">
                    <span className="postedit">Status :  </span>{" "}
                    
                    {eve.status}{" "}
                      {/* <p>{`${eve.status}`.slice(0,3)}</p> */}
                  </div>
            </div>
             </>
        })
    }
    </div>
    </div>
    </>
  )
}

export default DashmiuBoard

